import React from 'react'

interface Props {
  children: React.ReactNode
}

export const EmptyMessage = ({ children }: Props) => {
  return <div className="empty-message">{children}</div>
}
